const TrustPilotStarsSVG = () => (
    <svg viewBox="0 0 123 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#a)">
            <path d="M.473 22.538H23.03V0H.473v22.538Z" fill="#00B67A" />
            <path
                d="M19.704 9.587 6.909 18.874l1.867-5.74-4.887-3.547h6.04l1.867-5.74 1.867 5.74h6.04Zm-7.907 5.74 3.494-.734 1.392 4.28-4.886-3.546Z"
                fill="#fff"
            />
            <path d="M25.4 22.538h22.558V0H25.4v22.538Z" fill="#00B67A" />
            <path d="M25.4 22.538h11.28V0H25.4v22.538Z" fill="#00B67A" />
            <path
                d="m36.95 15.24 2.997-.647 1.386 4.378-4.7-3.504-4.882 3.504 1.895-5.76-4.96-3.56h6.131l1.894-5.76 1.895 5.76h6.131L36.95 15.24Z"
                fill="#fff"
            />
            <path d="M50.346 22.538h22.558V0H50.346v22.538Z" fill="#00B67A" />
            <path d="M50.346 22.538h11.279V0h-11.28v22.538Z" fill="#00B67A" />
            <path
                d="m69.577 9.587-12.795 9.287 1.867-5.74-4.887-3.547h6.04l1.867-5.74 1.867 5.74h6.04Zm-7.907 5.74 3.494-.734 1.392 4.28-4.886-3.546Z"
                fill="#fff"
            />
            <path d="M75.291 22.538h22.558V0H75.291v22.538Z" fill="#00B67A" />
            <path d="M75.291 22.538H86.57V0H75.291v22.538Z" fill="#00B67A" />
            <path
                d="m94.52 9.587-12.794 9.287 1.866-5.74-4.887-3.547h6.04l1.867-5.74 1.867 5.74h6.041Zm-7.907 5.74 3.494-.734 1.392 4.28-4.886-3.546Z"
                fill="#fff"
            />
            <path d="M100.221 22.538h22.558V0h-22.558v22.538Z" fill="#00B67A" />
            <path d="M100.221 22.538H111.5V0h-11.279v22.538Z" fill="#00B67A" />
            <path
                d="m119.45 9.587-12.795 9.287 1.867-5.74-4.887-3.547h6.041l1.866-5.74 1.867 5.74h6.041Zm-7.907 5.74 3.494-.734 1.392 4.28-4.886-3.546Z"
                fill="#fff"
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M.42 0h122.199v22.378H.419z" />
            </clipPath>
        </defs>
    </svg>
);

export default TrustPilotStarsSVG;
